import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { createLogger } from 'redux-logger'
import reducers from './reducer'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'
const loggerMiddleware = createLogger()
const persistConfig = {
  key: 'root',
  storage: storage,
  stateReconciler: autoMergeLevel2,
  whitelist: ['auth', 'userRights','lists', 'slas'],
}

const pReducer = persistReducer(persistConfig, reducers)

export const store = createStore(
  pReducer,
  applyMiddleware(thunk, loggerMiddleware)
)

export const persistor = persistStore(store)
